<template>
	<InstallLayout
		:show-back-btn="true"
		:show-exit-btn="true"
		:back-fn="goBack"
		:exit-fn="exit"
	/>
</template>

<script>
import _ from "lodash";

import InstallLayout from "./install/shared/Layout";

export default {
	components: { InstallLayout },

	methods: {
		goBack() {
			const routeDesc = _.get(this.$route, "meta.back");
			return this.$router.push(routeDesc);
		},

		exit() {
			return this.$router.push({ name: "Home" });
		},
	},
};
</script>
